import { memo, type ReactNode } from 'react';

import { type IconComponent } from '@air/design-icons';

import { NullState } from '~/components/NullState';

export type ContributableNullStateProps = {
  title: string;
  description: string;
  icon: IconComponent;
  cta?: ReactNode;
  'data-testid'?: string;
};

export const ContributableNullState = memo(
  ({ title, cta, description, icon, 'data-testid': testId }: ContributableNullStateProps) => (
    <NullState testId={testId} icon={icon} title={title} description={description}>
      {cta}
    </NullState>
  ),
);

ContributableNullState.displayName = 'ContributableNullState';
